import styles from "./DrawDetailPage.module.scss";
import { DrawDetailCard } from "../../components/DrawDetailCard/DrawDetailCard";
import { useCurrentDraw } from "../../hooks/draw";

export const DrawDetailPage = () => {
    const draw = useCurrentDraw();

    return (
        <div className={styles.tasksWrapper}>
            { draw && <DrawDetailCard draw={ draw } /> }
        </div>
    );
};

